import React from 'react';
import logo from 'assets/svgs/applogo_light.svg';
import './LoadingBlock.css';
import classNames from "classnames"

const LoadingLogo = ({style = {}, className = "h-48", logoSrc = logo}) => {
    return (
        <div style={{height: '100%', minHeight: '16rem', ...style}}
             className={classNames("loading-block-container", className)}
        >
            <img src={logoSrc}
                 alt="Loading..."
                 width={128}
                 height={128}
                 fetchpriority="high"
                 className="pulse-logo"
            />
        </div>
    );
};

export default React.memo(LoadingLogo);
